import { RouteRecordRaw } from 'vue-router';

const requestRoutes: RouteRecordRaw[] = [
  {
    path: '/request/:id',
    name: 'request-board',
    component: () => import('@/views/request/RequestBoard.vue'),
    meta: {
      isNeedLogin: true,
      type: 'request',
      title: 'request',
    },
  },
];

export default requestRoutes;


